export default "__VITE_ASSET__ZdgpHxNz__"